import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/raul/github/using-gatsby-mdx-remark-images/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`This is a homepage`}</h1>
    <p>{`Check out this big ass sunflower picture by `}<a parentName="p" {...{
        "href": "https://unsplash.com/photos/5lRxNLHfZOY"
      }}>{`Paul Green on
Unsplash`}</a>{`:`}</p>
    <p><a parentName="p" {...{
        "className": "gatsby-resp-image-link",
        "href": "/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/844a5/sunflower.jpg",
        "style": {
          "display": "block"
        },
        "target": "_blank",
        "rel": ["noopener"]
      }}>{`
    `}<span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1440px"
          }
        }}>{`
    `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "150%",
              "position": "relative",
              "bottom": "0px",
              "left": "0px",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
    `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0px",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0px",
              "left": "0px",
              "boxShadow": "inset 0px 0px 0px 400px white"
            },
            "alt": "Sunflower!",
            "title": "",
            "src": "/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/b97fe/sunflower.jpg",
            "srcSet": ["/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/419d9/sunflower.jpg 360w", "/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/cad07/sunflower.jpg 720w", "/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/b97fe/sunflower.jpg 1440w", "/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/0bf41/sunflower.jpg 2160w", "/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/0d268/sunflower.jpg 2880w", "/using-gatsby-mdx-remark-images/static/33e8481d634cf733e4da77c873baa560/844a5/sunflower.jpg 3112w"],
            "sizes": "(max-width: 1440px) 100vw, 1440px"
          }}></img>{`
  `}</span>{`
  `}</a></p>

    </MDXLayout>;
}
MDXContent.isMDXComponent = true;
      